export const SUPPLIER_REQUEST_STATUS = {
    ACTIVE: 0,
    DONE: 1,
    DELETED: 2,
} as const;

export const COMING_TRANSFER_NONE = 0;
export const COMING_TRANSFER_OBJECT = 1;
export const COMING_TRANSFER_RESERVE = 2;

export const DEFAULT_SUPPLIER_REQUEST_STATUSES = [SUPPLIER_REQUEST_STATUS.ACTIVE];

export const SUPPLIER_REQUESTS_PAGE_SIZE_KEY = 'supplier-requests';

export const SUPPLIER_REQUEST_NOTE_MAX_LENGTH = 300;
